<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Aggregates.vue?8d01c1f2